import "./MatchSkeleton.scss";

const SKELETON_CARDS = [0, 1, 2, 3];

const MatchHomeTabSkeleton = () => {
  return (
    <div className="match-skeleton-overlay">
      <div className="match-skeleton-overlay__list">
        {SKELETON_CARDS.map((i) => (
          <div className="match-skeleton-card" key={i} style={{ "--shimmer-delay": `${i * 0.15}s` }}>
            <div className="match-skeleton-card__img" />
            <div className="match-skeleton-card__lines">
              <div className="match-skeleton-card__line match-skeleton-card__line--short" />
              <div className="match-skeleton-card__line match-skeleton-card__line--long" />
              <div className="match-skeleton-card__line match-skeleton-card__line--medium" />
              <div className="match-skeleton-card__line match-skeleton-card__line--short" />
            </div>
          </div>
        ))}
      </div>
      <div className="match-skeleton-overlay__fade" />
    </div>
  );
};

export default MatchHomeTabSkeleton;
